import React from "react";

import styles from "./TextField.module.scss";
import TextBox from "components/TextBox";
import HelpHoverIcon from "components/HelpHoverIcon";

interface TextFieldProps {
  label: string;
  placeholder?: string;
  value: string;
  setValue: (val: string) => void;
  helpMessage?: string;
  disabled?: boolean;
  horizontal?: boolean;
  autoFocus?: boolean;
  error?: string;
}

const TextField = ({
  label,
  placeholder = "",
  value,
  setValue,
  helpMessage,
  disabled = false,
  horizontal = false,
  autoFocus = false,
  error,
}: TextFieldProps) => {
  return (
    <div
      className={`${styles.container} ${horizontal && styles.horizontalLayout}`}
    >
      <div className={styles.header}>
        <label className={styles.label}>{label}</label>
        {helpMessage && <HelpHoverIcon message={helpMessage} />}
      </div>
      <div className={styles.withError}>
        <TextBox
          lean
          unfilled
          error={!!error}
          disabled={disabled}
          autoFocus={autoFocus}
          value={value !== "" ? value : placeholder}
          onChange={setValue}
        />
        {error && <div className={styles.errorMessage}>{error}</div>}
      </div>
    </div>
  );
};

export default TextField;
